<template>

  <div class="bg-[#3E5463] bg-opacity-65 w-full h-[calc(100vh-91px)] flex justify-center items-end absolute inset-0 rounded-[20px] px-[12px] py-[19px]">

    <div class="h-[569px] w-full bg-white rounded-[20px] py-[12px] px-[9px] mb-[24px]">

      <div class="w-full bg-[#E0E9F0] h-[214px] rounded-[12px] pt-[56px] px-[26px]">
        <div class="flex justify-end">
          <div
              class="bg-[#c4d5e1] rounded-[12px] w-[100px] h-[54px] flex justify-center items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="67.766" height="22.597"
                 viewBox="0 0 67.766 22.597">
              <g id="Group_41" data-name="Group 41" transform="translate(-104.1 -367.8)">
                <rect id="Rectangle_59" data-name="Rectangle 59" width="28.666" height="9.55"
                      transform="translate(104.1 380.831)" fill="#84b740"/>
                <rect id="Rectangle_60" data-name="Rectangle 60" width="28.666" height="9.558"
                      transform="translate(104.1 367.8)" fill="#259bd6"/>
                <path id="Path_80" data-name="Path 80"
                      d="M724.911,509.845l-.128.026a4.179,4.179,0,0,1-.928.119c-.749,0-1.634-.383-1.634-2.187,0-.928.153-2.162,1.549-2.162h.008a4.193,4.193,0,0,1,1.021.2l.111.034Zm.23-9-.23.043v3.336l-.2-.06-.06-.017a4.7,4.7,0,0,0-1.268-.221c-2.792,0-3.379,2.111-3.379,3.881,0,2.426,1.362,3.822,3.736,3.822a7.576,7.576,0,0,0,2.494-.349,1.1,1.1,0,0,0,.936-1.209V500.5c-.664.119-1.353.238-2.026.349"
                      transform="translate(-563.479 -121.406)" fill="#27292d"/>
                <path id="Path_81" data-name="Path 81"
                      d="M823.509,546.317l-.119.034-.426.111a4.437,4.437,0,0,1-1.03.162c-.655,0-1.047-.323-1.047-.877,0-.357.162-.962,1.234-.962h1.387Zm-.979-6.017a9.419,9.419,0,0,0-2.843.494l-.715.213.238,1.617.7-.23a8.2,8.2,0,0,1,2.323-.392c.306,0,1.243,0,1.243,1.013v.443h-1.3c-2.375,0-3.473.757-3.473,2.383,0,1.387,1.013,2.221,2.715,2.221a8.778,8.778,0,0,0,1.889-.255l.034-.009.034.009.213.034c.664.119,1.353.238,2.026.366V542.9c0-1.719-1.038-2.6-3.081-2.6"
                      transform="translate(-653.779 -157.818)" fill="#27292d"/>
                <path id="Path_82" data-name="Path 82"
                      d="M629.209,546.317l-.119.034-.426.111a4.371,4.371,0,0,1-1.03.162c-.655,0-1.047-.323-1.047-.877,0-.357.162-.962,1.226-.962H629.2v1.532Zm-.97-6.017a9.376,9.376,0,0,0-2.843.494l-.715.213.238,1.617.7-.23a8.205,8.205,0,0,1,2.324-.392c.306,0,1.243,0,1.243,1.013v.443h-1.3c-2.375,0-3.481.757-3.481,2.383,0,1.387,1.013,2.221,2.724,2.221a8.778,8.778,0,0,0,1.889-.255l.034-.009.034.009.2.034c.672.119,1.353.238,2.026.374V542.9c.008-1.736-1.03-2.6-3.073-2.6"
                      transform="translate(-476.016 -157.818)" fill="#27292d"/>
                <path id="Path_83" data-name="Path 83"
                      d="M489.783,540.408a5.744,5.744,0,0,0-2.307.511l-.085.043-.077-.06a3.492,3.492,0,0,0-2.068-.5,8.461,8.461,0,0,0-2.443.366c-.723.221-1,.57-1,1.226v6.068h2.264v-5.609l.111-.034a2.881,2.881,0,0,1,1-.179.9.9,0,0,1,.987,1.03v4.8h2.23v-4.894a1.645,1.645,0,0,0-.068-.494l-.077-.145.153-.068a2.684,2.684,0,0,1,1.107-.23.9.9,0,0,1,.987,1.03v4.8h2.221v-5.022c0-1.779-.953-2.638-2.928-2.638"
                      transform="translate(-345.553 -157.91)" fill="#27292d"/>
                <path id="Path_84" data-name="Path 84"
                      d="M699.52,374.03a7.721,7.721,0,0,1-1.319-.119l-.128-.026v-3.277a1.6,1.6,0,0,0-.06-.468l-.068-.136.145-.06c.034-.017.068-.026.111-.043l.026-.017.153-.051a.216.216,0,0,1,.06-.017,5.285,5.285,0,0,1,1.166-.136h.008c1.387,0,1.549,1.234,1.549,2.162-.009,1.8-.9,2.187-1.643,2.187m-.008-6.23h-.06c-1.3,0-2.638.357-3.115,1.055a2.129,2.129,0,0,0-.409,1.268h0V373.5a1,1,0,0,1-.068.426l-.077.145h-4.111v-2.349h-.008c-.051-2.477-1.515-3.839-3.634-3.839h-2.068c-.085.6-.153,1.03-.238,1.634h2.06c1.081,0,1.651.919,1.651,2.332v2.366l-.145-.077a1.562,1.562,0,0,0-.485-.068h-3.558c-.068.451-.153,1.038-.247,1.626h10.937c.375-.077.809-.145,1.183-.2a6.161,6.161,0,0,0,2.29.417,4.061,4.061,0,0,0,.1-8.111"
                      transform="translate(-531.458)" fill="#27292d"/>
                <path id="Path_85" data-name="Path 85"
                      d="M494.431,377.7h.1c2.375,0,3.481-.783,3.481-2.715a2.486,2.486,0,0,0-2.715-2.494h-2.187a.943.943,0,0,1-1.047-1c0-.426.162-.953,1.234-.953h4.783c.1-.621.153-1.013.247-1.634h-4.971c-2.315,0-3.481.97-3.481,2.587,0,1.6,1.013,2.434,2.715,2.434h2.187a1.033,1.033,0,0,1,1.047,1.064,1.069,1.069,0,0,1-1.226,1.1h-.366l-7-.017h-1.277c-1.081,0-1.838-.613-1.838-2.034v-.979c0-1.481.587-2.4,1.838-2.4h2.077c.094-.63.153-1.03.238-1.626h-2.834c-2.119,0-3.583,1.421-3.634,3.9h0v1.106a3.359,3.359,0,0,0,3.634,3.66H487.5l3.8.009h3.132Z"
                      transform="translate(-345.553 -1.006)" fill="#27292d"/>
              </g>
            </svg>
          </div>
        </div>
        <div class="mt-[10px] text-[20px] mb-[6px] font-bold text-[#3E5463]">
          4859 8566 4666 6546
        </div>
        <div class="flex items-start">
          <div class="w-1/2">
            <div class="text-[15px] text-[#3E5463]"> {{lang === 'en' ? 'Name' : 'اسم'}} </div>
            <div class="text-[15px] font-bold text-[#3E5463] -mt-[3px]"> Yousef Abuzaid </div>
          </div>
          <div class="w-1/2 text-end">
            <div class="text-[15px] text-[#3E5463]"> {{lang === 'en' ? 'EXPIRES' : 'تنتهي'}} </div>
            <div class="text-[15px] font-bold text-[#3E5463] -mt-[3px]"> 02 /2025 </div>
          </div>
        </div>
      </div>

      <div class="mt-[9px] w-full">
        <div class="rounded-[10px] bg-white shadow-[0_4px_3px_0_#E0E9F0] mt-[8px] h-[64px] mb-[6px] px-[19.8px] py-[9px]">
          <label for="cardholder-name" class="text-[15px] text-[#3E5463]"> {{lang === 'en' ? 'Cardholder Name' : 'اسم حامل البطاقة'}} </label>
          <input id="cardholder-name" type="text" name="cardholder-name" value="Yousef Abuzaid" class="w-full border-0 outline-0 block text-[18px] font-medium text-[#3E5463]" required autoComplete="off"/>
        </div>
        <div class="rounded-[10px] bg-white shadow-[0_4px_3px_0_#E0E9F0] mt-[8px] h-[64px] mb-[6px] px-[19.8px] py-[9px]">
          <label for="cardholder-number" class="text-[15px] text-[#3E5463]"> {{lang === 'en' ? 'Card Number' : 'رقم البطاقة'}} </label>
          <input id="cardholder-number" type="text" name="cardholder-number" value="4859 8566 4666 6546" class="w-full border-0 outline-0 block text-[18px] font-medium text-[#3E5463]" required autoComplete="off"/>
        </div>
        <div class="flex gap-x-2">
          <div class="rounded-[10px] bg-white shadow-[0_4px_3px_0_#E0E9F0] mt-[8px] h-[64px] mb-[6px] px-[19.8px] py-[9px]">
            <label for="expires" class="text-[15px] text-[#3E5463]"> {{lang === 'en' ? 'EXPIRES' : 'تنتهي'}} </label>
            <input id="expires" type="text" name="expires" value="02/25" class="w-full border-0 outline-0 block text-[18px] font-medium text-[#3E5463]" required autoComplete="off"/>
          </div>
          <div class="rounded-[10px] bg-white shadow-[0_4px_3px_0_#E0E9F0] mt-[8px] h-[64px] mb-[6px] px-[19.8px] py-[9px]">
            <label for="card-number" class="text-[15px] text-[#3E5463]"> {{lang === 'en' ? 'CVV' : 'CVV'}} </label>
            <input id="cardholder-number" type="text" name="cardholder-number" value="559" class="w-full border-0 outline-0 block text-[18px] font-medium text-[#3E5463]" required autoComplete="off"/>
          </div>
        </div>
        <div class="mb-[9px]">
          <div class="h-[64px] w-full border border-[#C6A798] rounded-[12px] flex justify-between items-center px-[23px]">
            <div class="text-[15px] sm:text-[20px] font-bold text-[#3E5463]">
              {{lang === 'en' ? 'Save this card for later' : 'احفظ هذه البطاقة لاستخدامها لاحقًا'}}
            </div>
            <div class="h-full flex items-center">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input type="checkbox" class="peer w-[33.26px] h-[33.41px] cursor-pointer transition-all appearance-none rounded-full border border-[#C6A798] shadow hover:shadow-md checked:bg-[#C6A798]" />
                  <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="size-[25px]" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" stroke-width="1">
                      <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                    </svg>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <button type="submit" class="h-[64px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 w-full uppercase text-white text-[18px] sm:text-[21px] font-bold rounded-[12px]" @click="setOrderComplete($event)">
          {{lang === 'en' ? 'Pay with card' : 'الدفع بالبطاقة'}}
        </button>
      </div>

    </div>

  </div>

</template>

<script>

export default {
  data(){
    return {
      lang: window?.core?.lang,
    }
  },
  mounted() {

  },
  methods: {
    setOrderComplete(e){
      this.$emit('handleOrderComplete', e)
    }
  }
}

</script>